export enum NavigationKeyEnum {

    // Company Admin
    CompanyAdminLocations = 'companyadmin-locations',
    CompanyAdminApiTokens = 'companyadmin-api-tokens',
    CompanyAdminProducts = 'companyadmin-products',
    CompanyAdminProductEanRegistration = 'companyadmin-product-ean-registration',
    CompanyAdminProductEanRegistration2 = 'companyadmin-product-ean-registration-2',
    CompanyAdminProductBulkMarkingRegistration = 'companyadmin-product-bulk-marking-registration',
    CompanyAdminProductStockIn = 'companyadmin-product-stock-in',
    CompanyAdminProductStockOut = 'companyadmin-product-stock-out',
    CompanyAdminPackages = 'companyadmin-packages',
    CompanyAdminPackageDetail = 'companyadmin-package-detail',
    CompanyAdminTranslations = 'companyadmin-translations',
    CompanyAdminPromotions = 'companyadmin-promotions',
    CompanyAdminOperators = 'companyadmin-operators',
    CompanyAdminOperatorAccessLogs = 'companyadmin-operator-access-logs',
    CompanyAdminTransactions = 'companyadmin-transactions',
    CompanyAdminReceipts = 'companyadmin-receipts',
    CompanyAdminVouchers = 'companyadmin-vouchers',
    CompanyAdminSalesOverview = 'companyadmin-sales-overview',
    CompanyAdminTruckReport = 'companyadmin-truck-report',
    CompanyAdminTruckReportDetail = 'companyadmin-truck-report-detail',
    CompanyAdminTaggingAttendance = 'companyadmin-tagging-attendance',
    CompanyAdminLiveStore = 'companyadmin-live-store',
    CompanyAdminLiveWarehouse = 'companyadmin-live-warehouse',
    CompanyAdminWarehouseAnalysis = 'companyadmin-warehouse-analysis',
    CompanyAdminStoreAnalysis = 'companyadmin-store-analysis',
    CompanyAdminStatistics = 'companyadmin-statistics',
    CompanyAdminSettings = 'companyadmin-settings',
    CompanyAdminWarehouse = 'companyadmin-warehouse',
    CompanyAdminInventory = 'companyadmin-inventory',
    CompanyAdminInventoryRetail = 'companyadmin-inventory-retail',
    CompanyAdminInventoryLogistics = 'companyadmin-inventory-logistics',
    CompanyAdminInventoryManufacturing = 'companyadmin-inventory-manufacturing',
    CompanyAdminPaymentConfigurations = 'companyadmin-payment-configurations',
    CompanyAdminErosConfigurations = 'companyadmin-eros-configurations',
    CompanyAdminPriceTemplates = 'companyadmin-price-templates',
    CompanyAdminAiChat = 'companyadmin-ai-chat',
    CompanyAdminDevices = 'companyadmin-devices',
    CompanyAdminInsights = 'companyadmin-insights',
    CompanyAdminRoiCalculator = 'companyadmin-roi-calculator',
    CompanyAdminPisnerRoi = 'companyadmin-pisner-roi',
    CompanyAdminRfidBuilder = 'companyadmin-rfid-builder',

    CompanyAdminProductTypes = 'companyadmin-product-types',
    CompanyAdminWorkers = 'companyadmin-workers',
    CompanyAdminWasteCollectionContainers = 'companyadmin-waste-collection-containers',
    CompanyAdminWasteCollectionMap = 'companyadmin-waste-collection-map',
    CompanyAdminWasteCollectionRuns = 'companyadmin-waste-collection-runs',
    CompanyAdminWasteCollectionEvents = 'companyadmin-waste-collection-events',
    CompanyAdminWasteCollectionVehicles = 'companyadmin-waste-collection-vehicles',
    CompanyAdminWasteCollectionContainerTypes = 'companyadmin-waste-collection-container-types',
    CompanyAdminSortingTests = 'companyadmin-sorting-tests',
    CompanyAdminSortingTestsSamples = 'companyadmin-sorting-tests-samples',
    CompanyAdminSortingTestsStations = 'companyadmin-sorting-tests-stations',
    CompanyAdminSortingTestsLine = 'companyadmin-sorting-tests-line',
    CompanyAdminLabelDesigns = 'companyadmin-label-designs',

    // Super Admin
    SuperAdminCompanies = 'superadmin-companies',
    SuperAdminDevices = 'superadmin-devices',
    SuperAdminReaders = 'superadmin-readers',
    SuperAdminPrinters = 'superadmin-printers',
    SuperAdminFeatureFlags = 'superadmin-feature-flags',
    SuperAdminEanVersions = 'superadmin-ean-versions',
    SuperAdminEmailLogs = 'superadmin-email-logs',
    SuperAdminAntennaEpcTesting = 'superadmin-antenna-epc-testing',
    SuperAdminDummyCashRegister = 'superadmin-dummy-cash-register',
    SuperAdminCapabilityDefinitions = 'superadmin-capability-definitions',

    // Shared
    Home = 'superadmin-home',
    Users = 'superadmin-users',
    Profile = 'profile',
    AntennaMonitoring = 'superadmin-antenna-monitoring',
    ExternalApiLogs = 'superadmin-external-api-logs',
    LogsAntennaStats = 'logs-antenna-stats',
    LogsEpcReading = 'logs-epc-reading',
    LogsWarehouseNodeEpc = 'logs-warehouse-node-epc',
    LogsHooks = 'logs-hooks',
    EanRegistry = 'superadmin-ean-registry',
    CashRegisters = 'superadmin-cash-registers',
    PackingStations = 'superadmin-packing-stations',
    PackingStationsMonitor = 'company-admin-packing-stations-monitor',
}
